import PropTypes from 'prop-types'
import React from 'react'
import { withNamespaces } from 'react-i18next'

import './Accordion.scss'

export const Accordion = ({ headerData = [] }) => {
  const headers = headerData.map((item, index) => (
    <details key={index}>
      <summary>{item.title}</summary>
      <div
        className="sc-pr-pathway-header__accordion-content"
        dangerouslySetInnerHTML={{ __html: item.content }}
      ></div>
    </details>
  ))
  return <div className="sc-pr-pathway-header__accordion">{headers}</div>
}

Accordion.propTypes = {
  locale: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  headerData: PropTypes.array.isRequired,
}

export default withNamespaces('translations')(Accordion)
